export default "__VITE_ASSET__H23We2JN__"